var _classCallCheck = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/chad.schellenger/Development/shopwcw/ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var CartItem = require("./CartItem");

var Sku = require("./Sku");

var Cart =
/*#__PURE__*/
function () {
  "use strict";

  function Cart() {
    _classCallCheck(this, Cart);

    this.items = {};
    this.includeShipping = true;
    this.checkoutCode = '';
    this.checkoutCodeAgreed = false;
    this.addItem = this.addItem.bind(this);
    this.addShipping = this.addShipping.bind(this);
    this.cleanForDynamo = this.cleanForDynamo.bind(this);
    this.countItems = this.countItems.bind(this);
    this.discountAmount = this.discountAmount.bind(this);
    this.hasItem = this.hasItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.removeShipping = this.removeShipping.bind(this);
    this.shippingItem = this.shippingItem.bind(this);
    this.totalAmount = this.totalAmount.bind(this);
    this.totalItem = this.totalItem.bind(this);
  }

  _createClass(Cart, [{
    key: "addItem",
    value: function addItem(item) {
      _addItem(this, item);
    }
  }, {
    key: "addShipping",
    value: function addShipping() {
      this.includeShipping = true;
    }
  }, {
    key: "discountAmount",
    value: function discountAmount() {
      _discountAmount(this);
    }
  }, {
    key: "countItems",
    value: function countItems() {
      return _countItems(this);
    }
  }, {
    key: "hasItem",
    value: function hasItem() {
      return _hasItem(this);
    }
  }, {
    key: "removeItem",
    value: function removeItem(item) {
      return _removeItem(this, item);
    }
  }, {
    key: "removeShipping",
    value: function removeShipping() {
      _removeShipping(this);
    }
  }, {
    key: "shippingItem",
    value: function shippingItem() {
      return _shippingItem(this);
    }
  }, {
    key: "totalAmount",
    value: function totalAmount() {
      return _totalAmount(this);
    }
  }, {
    key: "totalItem",
    value: function totalItem() {
      return _totalItem(this);
    }
  }, {
    key: "cleanForDynamo",
    value: function cleanForDynamo() {
      return _cleanForDynamo(this);
    }
  }]);

  return Cart;
}();

function _addItem(cart, item) {
  var itemId = CartItem.itemId(item);
  console.log("Item id=%s, addStockings=%s", itemId, item.addStockings);

  if (cart.items[itemId] != null) {
    cart.items[itemId].quantity += item.quantity;
    cart.items[itemId].addStockings = item.addStockings;
  } else {
    cart.items[itemId] = item;
  }
}

function _removeItem(cart, item) {
  delete cart.items[CartItem.itemId(item)];
}

function addShipping(cart) {
  cart.includeShipping = true;
}

function _removeShipping(cart) {
  cart.includeShipping = false;
}

function _cleanForDynamo(cart) {
  if (cart.checkoutCode === '') {
    cart.checkoutCode = null;
  }
}

function _shippingItem(cart) {
  var shipPrice = 0;

  if (cart.includeShipping && _hasItem(cart)) {
    Object.values(cart.items).forEach(function (item) {
      for (var i = 0; i < item.quantity; i++) {
        if (shipPrice > 0) {
          // 10.00 for subsequent items
          shipPrice += 1000;
        } else {
          // 15.00 for initial item
          shipPrice += 1500;
        }
      }
    });
  }

  return CartItem.createCartItem({
    sku: Sku.createSku({
      id: "shipping",
      name: "Shipping",
      description: "Shipping",
      price: shipPrice
    })
  });
}

function _hasItem(cart) {
  return Object.values(cart.items).length > 0;
}

function itemEachAmount(item) {
  // full price - discount applied later
  var price = item.sku.price;

  if (item.addStockings) {
    // if there is a stocking add-on, add $5.00 each
    price += 500;
  }

  return price;
}

function itemAmount(item) {
  var price = itemEachAmount(item);
  return item.quantity * price;
}

function _discountAmount(cart) {
  var discount = 0;

  if (cart.checkoutCode === 'PICKUP') {
    cart.includeShipping = false;
  }

  return discount;
}

function _totalAmount(cart) {
  var amount = 0;

  for (var _i = 0, _Object$values = Object.values(cart.items); _i < _Object$values.length; _i++) {
    var item = _Object$values[_i];
    amount += itemAmount(item);
  }

  if (amount > 0 && cart.checkoutCode) {
    var discount = _discountAmount(cart);

    if (amount - discount > 0) {
      amount -= discount;
    } else {
      // never go negative.
      console.log("Refusing to include discount that would put us negative: %s", discount);
    }
  }

  if (amount > 0 && cart.includeShipping) {
    var ship = _shippingItem(cart);

    amount += ship.sku.price;
  }

  return amount;
}

function _countItems(cart) {
  var count = 0;
  Object.values(cart.items).forEach(function (item) {
    return count += item.quantity;
  });
  return count;
}

function _totalItem(cart) {
  return CartItem.createCartItem({
    sku: Sku.createSku({
      id: "total",
      name: "Total",
      description: "Order total",
      price: _totalAmount(cart)
    })
  });
}

function renderPrice(amount) {
  return "$" + (amount / 100).toFixed(2);
}

function createCart(obj) {
  var cart = new Cart();
  Object.values(obj.items).map(function (item) {
    return CartItem.createCartItem(item);
  }).forEach(function (item) {
    return _addItem(cart, item);
  });
  cart.includeShipping = obj.includeShipping;
  cart.checkoutCode = obj.checkoutCode;
  cart.checkoutCodeAgreed = obj.checkoutCodeAgreed;
  return cart;
}

module.exports = {
  addItem: _addItem,
  addShipping: addShipping,
  cart: Cart,
  cleanForDynamo: _cleanForDynamo,
  countItems: _countItems,
  createCart: createCart,
  discountAmount: _discountAmount,
  hasItem: _hasItem,
  itemAmount: itemAmount,
  itemEachAmount: itemEachAmount,
  removeItem: _removeItem,
  renderPrice: renderPrice,
  removeShipping: _removeShipping,
  shippingItem: _shippingItem,
  totalAmount: _totalAmount,
  totalItem: _totalItem
};